import { ChildId, ChildSex } from 'types/child';
import { Address } from 'types/common';

export type EnrollmentId = string & { readonly type: unique symbol };

export type CreateEnrollmentParentData = {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
};

export type CreateEnrollmentChildData = {
    firstName: string;
    lastName: string;
    sex: ChildSex;
    birthDate: string;
    birthPlace: string;
    pesel?: string;
};

export type AdditionalCriteriaDto = {
    multipleChildrenFamily?: boolean;
    childDisability?: boolean;
    siblingDisability?: boolean;
    oneParentDisability?: boolean;
    bothParentsDisability?: boolean;
    singleParenting?: boolean;
    fosterCare?: boolean;
};

export type CreateChildEnrollmentDTO = {
    parent: CreateEnrollmentParentData;
    child: CreateEnrollmentChildData;
    address?: Address;
    additionalCriteria?: AdditionalCriteriaDto;
};

export enum ApplicationStatus {
    NEW = 'NEW',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
}

export type EnrollmentItem = {
    id: EnrollmentId;
    schoolYear: string;
    status: ApplicationStatus;
    child: {
        id: ChildId;
        firstName: string;
        lastName: string;
        sex: ChildSex;
        address: Address | null;
    };
    parent: { firstName: string; lastName: string; phoneNumber: string };
};

export type GetEnrollmentFilterKey = 'status' | 'fromYear' | 'toYear';

export type EnrollmentFilters = {
    search?: string;
    status?: ApplicationStatus;
    fromYear?: number;
    toYear?: number;
};
